import React from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
  Typography,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from 'react-router-dom';
import { useLocation } from '../../contexts/LocationContext'; // Context for managing location

// Theme Colors
const themeColors = {
  primary: '#31C48D',
  grey: '#686978',
  white: '#FFFFFF',
  lightGrey: '#F1F1F1',
  text: '#4D4D4D',
};

// **City List**
const cityList = [
  { name: 'Jaipur', lat: 26.9124, lng: 75.7873 },

];

const GoogleMapSearchPlacesApi = () => {
  const { updateLocation } = useLocation(); // Context API for location update
  const navigate = useNavigate(); // Navigation hook

  // Save Location and Navigate
  const handleCitySelect = (city) => {
    // Update context with selected city details
    updateLocation(city.name, city.lat, city.lng);
    navigate('/dashboard'); // Redirect to dashboard
  };

  return (
    <Box
      sx={{
        padding: '16px',
        minHeight: '100vh',
        backgroundColor: themeColors.lightGrey,
      }}
    >
      {/* Header */}
      <Typography variant="h6" fontWeight="bold" mb={2} color={themeColors.text}>
        Select Your Location
      </Typography>

      {/* City List */}
      <List sx={{ boxShadow: 1, borderRadius: '8px', backgroundColor: themeColors.white }}>
        {cityList.map((city, index) => (
          <React.Fragment key={index}>
            <ListItem
              onClick={() => handleCitySelect(city)}
              sx={{
                cursor: 'pointer',
                '&:hover': { backgroundColor: themeColors.lightGrey },
                padding: '12px 16px',
              }}
            >
              <LocationOnIcon sx={{ color: themeColors.primary, marginRight: '10px' }} />
              <ListItemText
                primary={city.name}
                primaryTypographyProps={{
                  fontWeight: 'bold',
                  color: themeColors.text,
                }}
              />
              <ArrowForwardIosIcon fontSize="small" sx={{ color: themeColors.primary }} />
            </ListItem>
            {index !== cityList.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};

export default GoogleMapSearchPlacesApi;